<template>
  <div class="mx-auto">
    <div class="carousel slide mb-5 mt-5" data-ride="carousel" id="cizgi">
      <div class="carousel-inner">
        <div
          class="carousel-item"
          :class="{ active: i == 0 }"
          v-for="(img, i) in slider"
          :key="i"
        >
          <img
            :src="img.src"
            class="d-block w-100 img-fluid"
            alt="Ayancık Adak"
          />
          <div class="carousel-caption d-none d-md-block" v-scrollanimation>
            <h4 class="blur">{{ img.aciklama }}</h4>
            <p class="blur-p">
              +90 532 615 87 88 - Ergin TURAN / +90 536 207 24 58 - Ersin TURAN
            </p>
          </div>
        </div>
      </div>
      <a
        href="#cizgi"
        class="carousel-control-prev"
        role="button"
        data-slide="prev"
      >
        <span class="carousel-control-prev-icon"></span>
      </a>

      <a
        href="#cizgi"
        class="carousel-control-next"
        role="button"
        data-slide="next"
      >
        <span class="carousel-control-next-icon"></span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slider: [
        {
          src: "src/assets/slider/slider1.jpeg",
          aciklama: "HER BÜTÇEYE UYGUN ADAKLIK / KURBANLIK BULUNUR !",
        },
        {
          src: "src/assets/slider/slider2.jpeg",
          aciklama: "KESİM VE PARÇALAMA ÜCRETSİZ!",
        },
        {
          src: "src/assets/slider/slider3.jpg",
          aciklama: "ASİDER'İN TERCİHİ AYANCIK ADAK!",
        },
        {
          src: "src/assets/slider/slider4.jpg",
          aciklama:
            "ASİDER KURBAN KAMPANYASINA 50 ADET KÜÇÜKBAŞ KESİMİ YAPILDI",
        },
        {
          src: "src/assets/slider/slider5.jpg",
          aciklama: "HIZLI VE TEMİZ PAKETLEME",
        },
      ],
    };
  },
};
</script>

<style scoped>
.blur {
  text-transform: uppercase;
  background-color: rgb(51, 51, 51, 0.8);
  padding: 10px;
  margin-bottom: 15px;
}
.blur-p {
  background-color: rgb(51, 51, 51, 0.8);
  padding: 10px;
  display: inline !important;
  border-radius: 50px;
}
.carousel-inner {
  border-radius: 10px;
  -webkit-box-shadow: 0px 2px 30px 10px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 0px 2px 30px 10px rgba(0, 0, 0, 0.4);
  box-shadow: 0px 2px 30px 10px rgba(0, 0, 0, 0.4);
}
.carousel-caption {
  width: 100% !important;
  left: 0 !important;
}
.img-fluid {
  max-height: 600px !important;
  object-fit: cover !important;
}

.before-enter {
  opacity: 0;
  transform: scale(0.5);
  transition: all 1s cubic-bezier(0.42, 0.01, 0.51, 1.49);
}
.enter {
  opacity: 1;
  transform: scaleY(1);
}
</style>



// WEBPACK FOOTER //
// src/components/Slider.vue